import './CountdownAndPayTable.scss';
import { observer } from 'mobx-react';
import { betStore, roundStore, useTranslation, utilsStore } from '../../platform/stores';
import contractIcon from '../../assets/icons/contract.svg'
import { useRef } from 'react';

export const CountdownAndPayTable = observer(() => {
  const t = useTranslation();
  const { countDownDistance } = roundStore;
  const { setShowPayTableModal } = utilsStore;
  const { selectedNumbers, payTable, allBetsCount } = betStore;
  const tableRow = payTable[selectedNumbers.length];
  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;

  const getTrueNumber = (number: number): string => {
    if (number < 10) return '0' + number;
    return number.toString();
  }

  const payInfoRef = useRef(null);
  const minutes = getTrueNumber(Math.floor((countDownDistance % hour) / (minute)));
  const seconds = getTrueNumber(Math.floor((countDownDistance % minute) / second));

  return (
    <div className="countdown-and-pay-table-component">
      <div className="top">
        <div className="bets-count">
          <img src={contractIcon} alt="Contract icon"/>
          {allBetsCount}
        </div>
        <div className="countdown flex-center">
          <div className="countdown-item flex-center">{minutes}</div>
          <div className="dots">:</div>
          <div className="countdown-item flex-center">{seconds}</div>
        </div>
      </div>
      <div className="bottom">
        {
          selectedNumbers.length
            ?
            <div className="pay-table">
              <div className="pay-info" ref={payInfoRef}>
                <div className="line" style={{width: (payInfoRef.current as HTMLElement | null)?.scrollWidth}}></div>
                <div className="pay-item">
                  <div className="first">{t('MATCH')}</div>
                  <div>{t('PAYS')}</div>
                </div>
                <div className="flex-center">
                  {
                    Object.keys(tableRow).map((item) =>
                      <div className="pay-item text-center width bold" key={item}>
                        <div className="first">{item}</div>
                        <div>x{tableRow[item]}</div>
                      </div>
                    )
                  }
                </div>
              </div>
              <div className="info-icon flex-center cursor-pointer" onClick={() => setShowPayTableModal(true)}>i</div>
            </div>
            :
            <div className="message flex-center">{t('PLACE_YOUR_BET')}</div>
        }
      </div>
    </div>
  );
});
